import React from 'react'
import About from '../component/About'
import Footer from '../component/Footer'
import Hero from '../component/Hero'
import Navbar from '../component/Navbar'

const AboutRoute = () => {
  return (
    <>
    <Navbar/>
    <Hero/>
    <About/>
    <Footer/>
    </>
  )
}

export default AboutRoute